import React, { useState } from "react";

function SearchCom({ data, onSearch }) {
  const [searchQuery, setSearchQuery] = useState("");

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query); // Pass the query back to the parent component
  };

  return (
    <div className="flex-1 relative">
      <input
        type="text"
        placeholder="Search for something"
        className="w-full py-2 px-4 pl-10 rounded-full bg-white border border-gray-200"
        value={searchQuery}
        onChange={handleInputChange}
      />
    </div>
  );
}

export default SearchCom;
